


















import Vue, { PropType } from 'vue';
import { IContract } from '@/models';

export default Vue.extend({
  name: 'ContractRenewalDisplay',

  props: {
    contract: { type: Object as PropType<IContract>, required: true }
  },

  computed: {
    getFlagColor(): string {
      return this.contract.isInThirtyDayDurationThreshold()
        ? 'cancel'
        : 'orange';
    }
  }
});
